exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n    background-color: #F0F0F0;\n    display: block;\n    /* height: 100px; */\n}\n.ship-popup-wrapper {\n    padding: 15px;\n}\n\n::ng-deep .ship-popup-wrapper lfwms-result-data-table .lfwms-hdr-checkbox {\n    display: none;\n}\n/*\n::ng-deep .ship-popup-wrapper lfwms-result-data-table .header-content .icon-sort {\n    display: none;\n}\n\n\n::ng-deep .ship-popup-wrapper lfwms-result-data-table .header-content .ag-header-row {\n    \n}\n*/\n.ship-button {\n    margin-left:20px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/gen-interface-rec-popup/gen-inter-rec-popup.component.css
// module id = ../../../../../src/app/shared/lookup/gen-interface-rec-popup/gen-inter-rec-popup.component.css
// module chunks = main